import axios from "axios";
import { keycloakService } from "@Services/keycloak";
import { tokenRefreshService } from "@Services/tokenRefresh";

/**
 * Cliente axios para o estudo-rede-api (rotas /interno/* deste diagnóstico).
 * Mesmo padrão de auth do fleetManager: Bearer + x-customer-id.
 */
const estudoApi = axios.create({
  baseURL: process.env.REACT_APP_ESTUDO_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

estudoApi.interceptors.request.use(async (config) => {
  await keycloakService.ensureValidToken();

  const token = keycloakService.getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const customerId = localStorage.getItem("currentCompanyId");
  if (customerId) {
    config.headers["x-customer-id"] = customerId;
  }

  return config;
});

estudoApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      return tokenRefreshService.handle401Error(error, estudoApi);
    }
    return Promise.reject(error);
  }
);

export default estudoApi;
